<template>
  <v-footer
      height="auto"
      color="primary"
      class="footer"
  >
    <v-row justify="center" align="center" wrap>
      <v-col cols="12" md="3">
        <v-row justify="center" class="links">
          <v-btn
              text
              to="/imprint"
          >
            {{ $t("IMPRINT_LINK") }}
          </v-btn>
          <v-btn
              text
              to="/privacy"
          >
            {{ $t("PRIVACY_LINK") }}
          </v-btn>
          <v-btn
              text
              to="/tos"
          >
            {{ $t("TERMS_CONDITIONS_SHORTNAME") }}
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="paymentMethods">
        <div class="paymentText">
          <div v-if="paymentMethodActive('KLARNA_LATER')">
            <v-icon>check_circle_outline</v-icon>
            <span>{{ $t('FOOTER_PAY_PER_BILL') }}</span>
          </div>
          <div v-if="paymentMethodActive('BANK_TRANSFER')">
            <v-icon>check_circle_outline</v-icon>
            <span>{{ $t('FOOTER_PAY_PER_BANK_TRANSFER') }}</span>
          </div>
        </div>
        <div class="icons">
          <img v-if="paymentMethodActive('KLARNA_NOW')" src="@/assets/payment/klarna.svg" class="paymentIcon">
          <img v-if="paymentMethodActive('SOFORT')" src="@/assets/payment/sofort.svg" class="paymentIcon sofort">
          <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/visa.svg" class="paymentIcon visa">
          <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/mastercard.svg" class="paymentIcon">
          <img v-if="paymentMethodActive('CREDIT_CARD')" src="@/assets/payment/amex.svg" class="paymentIcon">
          <v-icon v-if="paymentMethodActive('BANK_TRANSFER')" class="paymentIcon" size="30px">account_balance</v-icon>
        </div>
      </v-col>
      <v-col
          primary
          py-3
          text-xs-center
          white--text
          cols="12" md="3"
      >
        <div class="copyright" v-html="$t('FOOTER_COPYRIGHT_NOTICE')"></div>
        <HelpBubble/>
      </v-col>
    </v-row>
  </v-footer>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import HelpBubble from "@/components/HelpBubble.vue";

@Component({
  components: {HelpBubble}
})
export default class Footer extends BasicComponent {

}

</script>
<style lang="scss" scoped>

.footer {
  padding: 10px;
  padding-top: 25px;

  .links {
    * {
      margin: 0;
    }
  }

  .paymentMethods {
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    border-radius: 5px;

    .icons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      .paymentIcon {
        display: inline-block;
        height: 30px;

        &.visa, &.sofort {
          height: 25px;
        }

        &:not(:first-of-type) {
          margin-left: 10px;
        }

        &:not(:last-of-type) {
          margin-right: 10px;
        }

        &.v-icon {
          margin-left: 10px;
        }
      }
    }

    .paymentText {
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      position: relative;

      *:not(:first-of-type) {
        padding-left: 15px;
      }

      *:not(:last-of-type) {
        padding-right: 15px;
      }

      div {
        display: flex;
        align-items: center;

        .v-icon {
          margin-right: 5px;
        }

      }
    }

    /*
    img {
      display: block;
      margin: 0 auto;
    }*/
  }
}

</style>
<style lang="scss">

.copyright {
  display: inline-block;

  p {
    margin: 0 !important;
  }
}

</style>
